import { z } from "zod";
export const CATEGORY_REVIEW_PERCENTAGES = {
    PRIMARY: 1,
    SECONDARY: 0.3,
};
export const groupSchema = z.object({
    PK: z.string(),
    SK: z.string(),
    GSI1_PK: z.string(),
    GSI1_SK: z.string(),
    path: z.string(),
});
export const globalCategorySchema = z.object({
    PK: z.string(),
    SK: z.string(),
    GSI1_PK: z.string(),
    GSI1_SK: z.string(),
    GSI2_PK: z.string(),
    GSI2_SK: z.string(),
    conflictingCategories: z.array(z.string()).optional(),
    depth: z.number(),
    description: z.string(),
    keywords: z.array(z.string()).optional(),
    mainGroup: z.string(),
    name: z.string(),
    path: z.string(),
    requireLocalZipCode: z.boolean(),
    reviewMetric: z.enum(["RxR", "Rating"]),
    serviceAreaBusinesses: z.boolean(),
    type: z.union([z.literal("General"), z.literal("Specialty")]),
    predictionMode: z
        .union([z.literal("Auto"), z.literal("Manual")])
        .default("Auto"),
});
export const localCategorySchema = z.object({
    PK: z.string(),
    SK: z.string(),
    GSI1_PK: z.string(),
    GSI1_SK: z.string(),
    GSI2_PK: z.string(),
    GSI2_SK: z.string(),
    awardYears: z.array(z.number()).default([]),
    children: z.array(z.string()).default([]),
    completedYears: z.array(z.number()).optional(),
    conflictingCategories: z.array(z.string()).optional(),
    description: z.string().default(""),
    depth: z.number(),
    existingQueued: z.number().default(0),
    groups: z.array(z.string()),
    finalistsYears: z.array(z.number()).optional(),
    finalizedYears: z.array(z.number()).optional(),
    keywords: z.array(z.string()).default([]),
    mainGroup: z.string(),
    name: z.string(),
    newQueued: z.number().default(0),
    path: z.string(),
    predictionMode: z
        .union([z.literal("Auto"), z.literal("Manual")])
        .default("Auto"),
    preselectedYears: z.array(z.number()).optional(),
    requireLocalZipCode: z.boolean(),
    reviewMetric: z.union([z.literal("RxR"), z.literal("Rating")]),
    serviceAreaBusinesses: z.boolean(),
    totals: z.record(z.string(), z.object({
        nominations: z.number(),
        votes: z.number(),
        finalized: z.number().default(0),
    })),
    type: z.union([z.literal("General"), z.literal("Specialty")]),
    winnersYears: z.array(z.number()).optional(),
});
//# sourceMappingURL=types.js.map